<template>
  <div>
    <NOdata v-if="this.curWarnList.length == 0 && isLoad" title="暂无预警~"></NOdata>
    <template v-else>
      <div class="grey-contain" v-for="(item,index) in curWarnList" :key="index" @click="warnDetail(item.warningId,item.dxid)">
        <p>{{item.semester}}</p>
        <span>上课专业：{{item.majorName}}</span>
        <span v-html="'处理结果：'+item.resultName"></span>
        <span v-html="'预警时间：'+ item.tjsj "></span>
        <span v-if="schoolCode == '10894'">{{ item.dxmc }}：{{ item.sjz }}</span>
        <span class="xx" v-if="schoolCode == '10894'">></span>
      </div>
    </template>
  </div>
</template>

<script>
  import { Api } from '../../../utils/axios'
  export default{
    data(){
      return{
        schoolCode:'',
        curWarnList:[],
        isLoad:false
      }
    },
    created(){
      this.schoolCode = sessionStorage.getItem("schoolCode");
      this.getList()
    },
    methods:{
      async getList(){
        const params = {
          isCurrent:'1'
        }
        const res = await Api.getStatueWaring(params)
        this.curWarnList = res.data;
        this.isLoad = true;
      },
      warnDetail(id,dxid){
        this.$router.push({
          path:'/student/warnDetail',
          query:{
            'id':id,
            'dxid':dxid
          }
        })
      }
    },
  }
</script>

<style lang="less" scoped>
  .grey-contain{flex-direction: column;align-items: flex-start;justify-content: center;line-height: 22px;position: relative;}
  .grey-contain p{font-weight: 600;}
  .grey-contain span{color: @attendance-color-2;font-size: 12px;}
  .warn-tab li{list-style: none;}
  .grey-contain .xx{
    position: absolute;
    right: 14px;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/statusManage/curWarn.vue